import {
  School,
  SchoolDocument,
  ParentContributionDocument,
} from '../models/schools.model';
import { Timestamp } from 'firebase/firestore';

const COLLATOR = new Intl.Collator('de', { sensitivity: 'base' });

/**
 * Returns all documents visible to parents, sorted alphabetically by title (German locale).
 *
 * Includes a backward-compatibility fallback: if `school.documents` is empty/missing
 * but the legacy `school.parentContributionDocument` field is set, that legacy entry
 * is rendered as a synthetic SchoolDocument with title "Beitragsordnung" so the
 * customer-ui keeps working until the migration script has run.
 */
export function getVisibleDocuments(school: School): SchoolDocument[] {
  const list = school.documents ?? [];

  if (list.length === 0 && school.parentContributionDocument) {
    return [legacyToSchoolDocument(school.parentContributionDocument)];
  }

  return sortDocumentsByTitle(list.filter((d) => d.visibleToParents));
}

/** Returns a new array sorted by `title` using German locale collation. */
export function sortDocumentsByTitle(docs: SchoolDocument[]): SchoolDocument[] {
  return [...docs].sort((a, b) => COLLATOR.compare(a.title, b.title));
}

function legacyToSchoolDocument(legacy: ParentContributionDocument): SchoolDocument {
  return {
    id: 'legacy-parent-contribution',
    title: 'Beitragsordnung',
    originalFileName: legacy.originalFileName,
    fileName: legacy.fileName,
    storagePath: legacy.storagePath,
    downloadUrl: legacy.downloadUrl,
    mimeType: legacy.mimeType,
    fileSize: legacy.fileSize,
    visibleToParents: true,
    uploadedBy: legacy.uploadedBy,
    createdOn: legacy.createdOn ?? (Timestamp.now() as Timestamp),
  };
}
